import React from 'react';
import { FormattedMessage } from 'react-intl';
import { ClockCircleFilled, ArrowRightOutlined } from '@ant-design/icons';

interface IProps {
  // Absolute URL that re-runs the search for this quote's engine. When empty the
  // "search again" link is hidden (we could not derive a usable search URL).
  searchAgainUrl?: string;
}

// Banner shown at the top of every tab of an expired (historical) quote, explaining that
// the prices/availability are stale and offering a link to re-run the search.
export const ExpiredQuoteNotice: React.FC<IProps> = ({ searchAgainUrl }) => (
  <div className="quote-expired-notice">
    <ClockCircleFilled className="quote-expired-notice__icon" />
    <div className="quote-expired-notice__body">
      <div className="quote-expired-notice__title">
        <FormattedMessage id="quotes.expired.title" defaultMessage="This quote has expired." />
      </div>
      <div className="quote-expired-notice__subtitle">
        <FormattedMessage
          id="quotes.expired.subtitle"
          defaultMessage="Prices and availability shown here are no longer current."
        />
      </div>
      {searchAgainUrl ? (
        <a className="quote-expired-notice__link" href={searchAgainUrl} target="_blank" rel="noreferrer">
          <FormattedMessage id="quotes.expired.search.again" defaultMessage="Search again with new dates" />
          <ArrowRightOutlined className="quote-expired-notice__link-arrow" />
        </a>
      ) : null}
    </div>
  </div>
);
